






























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { GridLayout, GridItem } from 'vue-grid-layout';

import DxButton from 'devextreme-vue/button';
import { DxLoadPanel } from 'devextreme-vue/load-panel';

import ChartRender from '@/components/charts/ChartRender.vue';
import DashboardItem from './dashboard-item.vue';

import {
	apiService, customerService
} from '@/container';

@Component({
	components: {
		DashboardItem,
		ChartRender,
		DxButton,
		DxLoadPanel,
		GridLayout, GridItem
	}
})
export default class DashboardGrid extends Vue {
	@Prop({ type: String, default: null }) idDashboard!: string | null;
	@Prop({ type: Boolean, default: false }) canEditCharts!: boolean;
	@Prop({ type: String, default: '#dashboard-grid-loading' }) loadPanelPosition!: string;

	position = { of: this.loadPanelPosition };
	loadGridItems = false;
	isLoading = false;

	layout: any[] = [];

	async mounted() {
		this.$emit('update:reload', async () => await this.loadDashboard());
		await this.loadDashboard();
	}

	get areChartsDefinedForDashboard() {
		return this.layout !== undefined && this.layout.length > 0;
	}

	async loadDashboard() {
		this.loadGridItems = false;
		this.isLoading = true;
		this.$emit('load:start');
		if (_.isString(this.idDashboard)) {
			// const dashboard = await apiService.get<IDashboard>('dashboards', `${this.idDashboard}`);
			this.layout = await apiService.get('dashboards', `${this.idDashboard}/charts`);
      await apiService.post('dashboards', 'createDashboardUserSelection',{
                                                                          IdDashboard :this.idDashboard,
                                                                          IdCustomer: customerService.getCustomer()
                                                                        });
		}
		this.isLoading = false;
		this.$emit('load:end');
	}

	async onGridItemMoved() {
		this.isLoading = true;
		apiService.post('dashboards', `${this.idDashboard}/updateGrid`, this.layout);
		this.isLoading = false;
	}

	async onGridItemResized() {
		this.isLoading = true;
		apiService.post('dashboards', `${this.idDashboard}/updateGrid`, this.layout);
		this.isLoading = false;
	}

	@Watch('idDashboard')
	async onIdDashboardChange(newValue: string | null, oldValue: string | null) {
		if (_.isString(newValue) && newValue !== oldValue)
			await this.loadDashboard();
	}
}
